import React from 'react';
import { DatePicker, Select, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import type { SalesConversionReportFilters } from '@/services/salesConversionReports.service';

const { RangePicker } = DatePicker;

export type SalesReportFilterBarProps = {
  value: SalesConversionReportFilters;
  onChange: (next: SalesConversionReportFilters) => void;
  showFunnelMode?: boolean;
  showCompare?: boolean;
};

export function defaultSalesReportFilters(): SalesConversionReportFilters {
  return {
    date_from: dayjs().startOf('month').format('YYYY-MM-DD'),
    date_to: dayjs().endOf('month').format('YYYY-MM-DD'),
    funnel_mode: 'volume',
    compare_to: 'prior_period',
  };
}

export const SalesReportFilterBar: React.FC<SalesReportFilterBarProps> = ({
  value,
  onChange,
  showFunnelMode = false,
  showCompare = true,
}) => {
  const range: [Dayjs, Dayjs] | null =
    value.date_from && value.date_to
      ? [dayjs(value.date_from), dayjs(value.date_to)]
      : null;

  return (
    <Space wrap style={{ marginBottom: 16 }}>
      <RangePicker
        value={range}
        onChange={(v) => {
          if (!v?.[0] || !v?.[1]) return;
          onChange({
            ...value,
            date_from: v[0].format('YYYY-MM-DD'),
            date_to: v[1].format('YYYY-MM-DD'),
          });
        }}
      />
      {showFunnelMode && (
        <Select
          style={{ width: 160 }}
          value={value.funnel_mode || 'volume'}
          onChange={(funnel_mode) => onChange({ ...value, funnel_mode })}
          options={[
            { value: 'volume', label: 'Volume mode' },
            { value: 'cohort', label: 'Cohort mode' },
          ]}
        />
      )}
      {showCompare && (
        <Select
          allowClear
          style={{ width: 180 }}
          placeholder="Compare to"
          value={value.compare_to || undefined}
          onChange={(compare_to) => onChange({ ...value, compare_to: compare_to || '' })}
          options={[
            { value: 'prior_period', label: 'Prior period' },
            { value: 'prior_year', label: 'Prior year' },
          ]}
        />
      )}
    </Space>
  );
};
